import classNames from "classnames";
import React from "react";

interface RelatedItemsInfoProps {
    virtualParentInvNo?: string;
    virtualCollectionDescriptionString: string;
    virtualParentRelationships: number;
    virtualParentMedium: string;
    virtualCollectionLinkString?: string;
    isVirtualObject?: boolean;
}

const RelatedItemsInfo: React.FC<RelatedItemsInfoProps> = ({
    virtualCollectionDescriptionString,
    virtualCollectionLinkString,
    virtualParentRelationships,
    virtualParentMedium,
    virtualParentInvNo,
    isVirtualObject,
}) => {
    return (
        <div
            className={classNames("RelatedItemsInfo__link-to-parent-container", {
                "RelatedItemsInfo__link-to-parent-container--is-virtual-object": isVirtualObject,
            })}
        >
            <span className="RelatedItemsInfo__link-to-parent-number">{virtualParentRelationships}</span>
            <span className="RelatedItemsInfo__link-to-parent-description">
                {virtualCollectionDescriptionString
                    .replace("{medium}", virtualParentMedium)
                    .replace("{0}", `${virtualParentRelationships}`) + " "}
                {virtualCollectionLinkString && virtualParentInvNo && (
                    <a href={virtualParentInvNo} className="RelatedItemsInfo__link-to-parent">
                        {virtualCollectionLinkString}
                    </a>
                )}
            </span>
        </div>
    );
};

export default RelatedItemsInfo;
